// eslint-disable-next-line import/no-anonymous-default-export
export default {
  fonts: {
    uniText:"Unitext",
    montSerrat: "Montserrat",
  },

  modal: true,

  colors: {
    primary: "#ef002f",
    primaryLight: "#fe7f85",
    primaryDark: "#990b1c",
    secondary: "#52b3aa",
    secondaryLight: "#64bbb3",
    secondaryDark: "#377d76",
    white: "#fff",
    black: "#000",
    gray: "#373737",
    landingTheme: "#ADDFEA",
  },

  fontSizes: {
    small: "14px",
    medium: "18px",
    large: "25px",
    xxLarge: "36px"
  },

  borderRadius: {
    small: "2px",
    medium: "5px",
    large: "10px"
  },

  breakpoints: {
    tablet: "1024px",
    medium: "768px",
    mobile: "520px",
  },

  fontWeights: {
    light: 300,
    normal: 400,
    bold: 700,
    extraBold: 900,
  },

  layout: {
    row: "1280px",
  },
};
